var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCircleClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FF7925"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3667 7.42195C16.7572 7.03143 16.7572 6.39826 16.3667 6.00774C15.9761 5.61721 15.343 5.61721 14.9524 6.00774L11.1874 9.77281L7.42231 6.00774C7.03178 5.61721 6.39862 5.61721 6.00809 6.00774C5.61757 6.39826 5.61757 7.03143 6.00809 7.42195L9.77316 11.187L6.00761 14.9526C5.61709 15.3431 5.61709 15.9763 6.00761 16.3668C6.39814 16.7573 7.0313 16.7573 7.42183 16.3668L11.1874 12.6012L14.9529 16.3668C15.3435 16.7573 15.9766 16.7573 16.3671 16.3668C16.7577 15.9763 16.7577 15.3431 16.3671 14.9526L12.6016 11.187L16.3667 7.42195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircleClose);
export default __webpack_public_path__ + "static/media/ic-circleClose.0be1f305647a4f24a947657f4d8ecfa5.svg";
export { ForwardRef as ReactComponent };